import React from "react";
var __jsx = React.createElement;
import stl from "./DaysComponent.module.css";
import { useState } from "react";
import { useEffect } from "react";
var SingleDay = function SingleDay(_ref) {
  var day = _ref.day,
    dayName = _ref.dayName,
    isActive = _ref.isActive,
    disabled = _ref.disabled,
    activate = _ref.activate;
  var _useState = useState(false),
    active = _useState[0],
    setActive = _useState[1];
  useEffect(function () {
    setActive(isActive);
  }, [isActive]);
  return /*#__PURE__*/React.createElement("div", {
    "data-enabled": !disabled,
    onClick: activate !== null && activate !== void 0 ? activate : undefined,
    className: [stl.DayContainer, isActive ? stl.isActive : undefined].join(" "),
    disabled: disabled
  }, /*#__PURE__*/React.createElement("span", null, dayName), /*#__PURE__*/React.createElement("div", null, day));
};
export default SingleDay;